import { apiV1 } from '~/services/api';

export const charge = async (objectId: string) => {
  const response = await apiV1.request({
    method: 'PUT',
    url: `/invoices/${objectId}/charge`,
  });

  return response.data;
};

export const get = async (page?: number, count?: number) => {
  const response = await apiV1.request({
    method: 'GET',
    params: {
      page,
      results: count,
    },
    url: '/v1/invoices/',
  });

  return response.data;
};

export const getById = (invoiceId: string) =>
  apiV1.request({
    method: 'GET',
    url: `/v1/invoices/${invoiceId}`,
  });

// Implemented this service in this file instead of invoice-items.service.ts since this hits the /invoices endpoint
export const getInvoiceItemsOfInvoice = (invoiceId: string) =>
  apiV1.request({
    method: 'GET',
    url: `/v1/invoices/${invoiceId}/items?results=200`, // Limits the request to get up to 200 invoice items, copied from legacy code
  });
